<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Autorizzazioni funzioni</h1>
      </div>
      <p class="editor-lead">Assegna le autorizzazioni sulle funzioni per ogni utente.</p>
    </header>

    <form class="editor-form" [formGroup]="permissionsForm">
      <section class="editor-panel">
        <h2>Utenti e funzioni</h2>

        @if (authorizations.length === 0) {
          <p class="editor-hint">Nessun utente in elenco.</p>
        } @else {
          <div class="user-list" formArrayName="authorizations">
            @for (authorization of authorizations.controls; track authorization.get('user')?.get('id')?.value; let i = $index) {
              <div class="user-card" [formGroupName]="i">
                <div class="user-identity">
                  <span class="user-name">{{ authorization.get('user')?.get('name')?.value || '—' }}</span>
                  @if (authorization.get('user')?.get('email')?.value) {
                    <span class="user-email">{{ authorization.get('user')?.get('email')?.value }}</span>
                  }
                </div>

                <div class="permission-grid" formArrayName="permissions">
                  @for (permissionControl of getPermissionsControls(i).controls; track permissionControl.get('idfunction')?.value; let j = $index) {
                    <label class="check-field" [formGroupName]="j"
                      [attr.title]="permissionsList[j]?.description || null">
                      <input type="checkbox" formControlName="authorization">
                      <span>{{ permissionsList[j]?.name || permissionControl.get('function_name')?.value || 'Funzione' }}</span>
                    </label>
                  }
                </div>
              </div>
            }
          </div>
        }
      </section>

      <div class="editor-actions">
        <button class="editor-save" type="button" [disabled]="authorizations.length === 0" (click)="save()">
          Salva
        </button>
      </div>
    </form>
  </div>
</div>
